var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47676 4.99376C7.47676 4.72106 7.6978 4.5 7.97047 4.5C8.24314 4.5 8.46418 4.72106 8.46418 4.99376V8.50624C8.46418 8.77894 8.24314 9 7.97047 9C7.6978 9 7.47676 8.77894 7.47676 8.50624V4.99376Z",
    fill: "#E64539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97047 10.0125C7.6978 10.0125 7.47676 10.2336 7.47676 10.5062C7.47676 10.7789 7.6978 11 7.97047 11C8.24314 11 8.46418 10.7789 8.46418 10.5062C8.46418 10.2336 8.24314 10.0125 7.97047 10.0125Z",
    fill: "#E64539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7797 11.5788L15.7824 11.5835C16.4081 12.6742 15.6058 14 14.3781 14H1.62185C0.394157 14 -0.408056 12.6742 0.217591 11.5835L0.220316 11.5788L6.62856 0.802985C6.77126 0.557594 6.97573 0.355234 7.22016 0.214908C7.46595 0.0737986 7.74408 0 8.02647 0C8.30886 0 8.58699 0.0737986 8.83278 0.214908C9.07724 0.355246 9.28171 0.557626 9.42442 0.803039L15.7797 11.5788ZM8.40079 1.39991L14.7546 12.1732C14.9191 12.4599 14.7114 12.815 14.3781 12.815H1.62185C1.28864 12.815 1.08092 12.4599 1.24537 12.1732L7.65215 1.39991C7.68983 1.33463 7.74431 1.28037 7.81005 1.24263C7.87579 1.20489 7.95045 1.18501 8.02647 1.18501C8.10249 1.18501 8.17715 1.20489 8.24289 1.24263C8.30863 1.28037 8.36311 1.33463 8.40079 1.39991Z",
    fill: "#E64539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.41afe0a7ce7de8396e6ce0c5734d67e6.svg";
export { ForwardRef as ReactComponent };